import React, { useEffect, useRef, useState } from "react";
import Agendas from "./Agendas";
import { UseAPICaller } from "../../apiCaller";


import "../../css/AppDialog.css";

export interface AppDialogProps {
  isOpen: boolean;
}

const CompanyInfoDialogContent : React.FC<AppDialogProps> = ({isOpen}) => 
{
    const {GetEditableCompanyInfo, UpdateCompanyInfo, UploadCompanyImage} = UseAPICaller();

    const [companyData, setCompanyData] = useState<{doing:string, solving:string, target:string, agendas:[]}>({doing:"", solving:"",target:"",agendas:[]});
    
    useEffect(() => {
            if (!isOpen) return;
    
            const GetCompanyData = async () =>{
                const companyString = sessionStorage.getItem("company");
                if (companyString) 
                {
                    const company = JSON.parse(companyString);
                    const data = await GetEditableCompanyInfo(company.companyId);
                    console.log(data);
                    setCompanyData(data);
                }
            }
            GetCompanyData();
            
        }, [isOpen]);

    const OnAgendaChange = (newSelected: []) => {
        setCompanyData(prev => ({ ...prev, agendas: newSelected }));
    }

    const handleChange = (newData) => {
        setCompanyData((prev) => ({ ...prev, ...newData }));
    };

    const OnSave = () => {
        const companyString = sessionStorage.getItem("company");
        if (companyString) 
        {
            const company = JSON.parse(companyString);
            console.log(companyData);
            UpdateCompanyInfo(company.companyId, companyData);
        }
    };

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const companyString = sessionStorage.getItem("company");
        if (!companyString) return;

        const company = JSON.parse(companyString);
        const res = await UploadCompanyImage(company.companyId, file);

        if(res)
            if (fileInputRef.current) 
                fileInputRef.current.value = '';
    };

    const onUploadImage = () => {
        fileInputRef.current?.click();
    };
    
    return (
         <div className="dialog-body">
            <div className="dialog-column-left">
                <div style={{display:"flex", flexDirection:"column", gap:6}}>
                    <button className="dialog-button save-button" onClick={OnSave} style={{borderStyle:"solid"}}>Save</button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                    <button className="dialog-button blue-button" onClick={onUploadImage}>{"Upload Image (Max. 2mb)"}</button>
                </div>
            </div>
            <div className="dialog-column-middle">
                <div style={{display:"flex", flexDirection:"column"}}>
                    <label>What is your company doing, and your goals?</label>
                    <textarea 
                    value={companyData.doing}
                    onChange={e => handleChange( {doing: e.target.value})}
                    style={{width:"100%", height:220}} 
                    placeholder="What are you doing? What are you goals?"></textarea>
                </div>
                <div style={{display:"flex", flexDirection:"column"}}>
                    <label>What are you solving?</label>
                    <textarea 
                    value={companyData.solving}
                    onChange={e => handleChange( {solving: e.target.value})}
                    style={{width:"100%", height:220}} 
                    placeholder="What are you solving and how?"></textarea>
                </div>
            </div>
            <div className="dialog-column-right">
                <div style={{display:"flex", flexDirection:"column"}}>
                    <label>Who are you targeting?</label>
                    <textarea 
                    value={companyData.target}
                    onChange={e => handleChange( {target: e.target.value})}
                    style={{width:"100%", height:220}} 
                    placeholder="Targets..."></textarea>
                </div>
                <Agendas selected={companyData.agendas} onChange={OnAgendaChange} size={70} title="What are your agenda 2030 goals?"/>
            </div>
        </div>
    );
}

export default CompanyInfoDialogContent;